import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchIntegratedPlatform,destoryStore,resetNotification } from './integratedSlice';
import { DataGrid } from '@mui/x-data-grid';
import LinearProgress from '@mui/material/LinearProgress';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import EditIcon from '@mui/icons-material/Edit';
import Card from '@mui/material/Card';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import PlatformImage from '../../General/PlatformImage'
import PlatformDrawer from '../../General/PlatformDrawer';
import SettingsStatus from '../../../pages/General/SettingsStatus'
import Notification from '../../../pages/General/Notification'

// Modernized and refined enterprise dialog box configuration profile
const deleteModalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: '#FFFFFF',
    borderRadius: '16px',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    border: '1px solid #E2E8F0',
    p: 3.5,
    overflow: 'hidden',
    outline: 'none'
};

const IntegratedPage = ({ loading, data }) => {
    const integrate = useSelector(state => state.integrated && state.integrated);
    const integrated = useSelector(state => state.integrated);
    
    const [currentCategory, setCurrentCategory] = useState('all');
    const [orderDrawerVisible, setOrderDrawerVisible] = useState(false);
    const [platformName, setPlatformName] = useState('all');
    const [storeName, setStoreName] = useState('all');
    const [storeId, setStoreId] = useState('all');
    const [deleteid, setDeleteId] = React.useState("");
    const [deleteModalopen, setDeleteModalopen] = React.useState(false);
    
    const platformCallback = (platform,name,id) => {
        if(platform==='SHOPIFY_APP'){
            platform='SHOPIFY'
        }       
        setPlatformName(platform)
        setStoreName(name)
        setStoreId(id)    
        setOrderDrawerVisible(true)
    }
    
    const orderOnClose = (values) => {
        setOrderDrawerVisible(false);
    };
    const handleClick = (id) => {
        setDeleteId(id)
        setDeleteModalopen(true);
    };
     const deleteModalClose = () => {
        setDeleteModalopen(false);
    };

    const deleteStore = (id) => {
        dispatch(destoryStore({"store_id":id}))
        setDeleteModalopen(false);
    }

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchIntegratedPlatform())
    }, [dispatch])

    const columns = [
        {
        field: "platform",
        headerName: 'Platform',
        width: 110,
        resizable: false,           
        renderCell: (params) => {
            return (
                <Box 
                    sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        height: '100%', 
                        pl: 1,
                        lineHeight: 'normal', // 👈 Resets line-height calculation
                        '& img': {
                            display: 'block' // 👈 Prevents inline baseline alignment issues
                        }
                    }}
                >
                    <PlatformImage platform={params.row.platform} width={"32px"} />
                </Box>
            )
        }
    },
        { 
            field: 'store_name', 
            headerName: 'Store',
            width:300,
            resizable: false, 
            flex: 1,
            renderCell: (params) => (
                <Typography sx={{ fontSize: '13.5px', fontWeight: 600, color: '#1E293B', display: 'flex', alignItems: 'center', height: '100%' }}>
                    {params.value}
                </Typography>
            )
        },
        { 
            field: 'is_installed', 
            headerName: 'Status',
            minWidth: 130,
            resizable: false,
            renderCell: (params) => {
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                        <SettingsStatus settingsStatus={params.row.is_installed} />
                    </Box>
                )
            } 
        },
        {
            field: 'Actions',
            headerName: 'Actions',
            resizable: false,
            minWidth: 120,
            sortable: false,
            renderCell: (params) => {
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, height: '100%' }}>
                        <Tooltip title="Edit Pipeline" placement="top">
                            <Box 
                                sx={{ 
                                    display: 'inline-flex',
                                    p: 0.8,
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    color: '#1976d2',
                                    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                                    '&:hover': {
                                        backgroundColor: 'rgba(25, 118, 210, 0.06)',
                                        transform: 'scale(1.05)'
                                    }
                                }}
                                onClick={(e) => {
                                    platformCallback(params.row.platform,params.row.store_name,params.row.store_id)
                                }}
                            >
                                <EditIcon fontSize="small" />
                            </Box>
                        </Tooltip>
                        
                        {params && params.row && params.row.platform && params.row.platform==="ZONOS" &&
                            <Tooltip title="Delete Store Connection" placement="top">
                                <Box 
                                    sx={{ 
                                        display: 'inline-flex',
                                        p: 0.8,
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        color: '#DC2626',
                                        transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                                        '&:hover': {
                                            backgroundColor: 'rgba(220, 38, 38, 0.06)',
                                            transform: 'scale(1.05)'
                                        }
                                    }}
                                    onClick={(e) => {
                                        handleClick(params.row.store_id)
                                    }}
                                >
                                    <DeleteOutlineOutlinedIcon fontSize="small" />
                                </Box>
                            </Tooltip>
                        }
                    </Box>
                )
            }
        }
    ];

    return (
        <>
            {(integrated && integrated.notification && integrated.notification.show) &&
                <Notification
                    is_open={integrated.notification.show}
                    messageType={integrated.notification.messageType}
                    messages={integrated.notification.messageContent}
                    handleClose={() => dispatch(resetNotification())}
             />}
            {loading && <Card loading={loading} />}
            
            {/* High-End Refactored Modal Confirmation Box Container */}
            <Modal
                open={deleteModalopen}
                onClose={deleteModalClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                closeAfterTransition
            >
                <Box sx={deleteModalStyle}>
                    <Typography 
                        id="modal-modal-title" 
                        variant="h6" 
                        component="h2" 
                        sx={{ fontWeight: 800, color: '#0F172A', mb: 1.5 }}
                    >
                        Delete Store Connection
                    </Typography>
                    
                    <Typography 
                        id="modal-modal-description" 
                        variant="body2" 
                        sx={{ color: '#64748B', fontWeight: 500, lineHeight: 1.5, mb: 3.5 }}
                    >
                        Are you sure you want to delete this Store? This operational pipeline change cannot be undone.
                    </Typography>
                    
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1.5 }}>
                        <Button
                            variant="outlined"
                            onClick={deleteModalClose}
                            sx={{
                                textTransform: 'none',
                                borderRadius: '10px',
                                fontWeight: 700,
                                fontSize: '13.5px',
                                px: 3,
                                borderColor: '#E2E8F0',
                                color: '#475569',
                                '&:hover': {
                                    borderColor: '#CBD5E1',
                                    backgroundColor: '#F8FAFC',
                                    color: '#1E293B'
                                }
                            }}
                        >
                            No, Cancel
                        </Button>
                        <Button
                            variant="contained"
                            onClick={(event) => {
                                deleteStore(deleteid)
                            }}
                            sx={{
                                textTransform: 'none',
                                borderRadius: '10px',
                                fontWeight: 700,
                                fontSize: '13.5px',
                                px: 3,
                                boxShadow: 'none',
                                backgroundColor: '#DC2626',
                                color: '#FFFFFF',
                                '&:hover': {
                                    backgroundColor: '#B91C1C',
                                    boxShadow: 'none'
                                }
                            }}
                        >
                            Yes, Delete
                        </Button>
                    </Box>
                </Box>
            </Modal>
            
            {/* Header Content Section Title Label Block */}
            <Box className="integrated--stores--title" sx={{ textAlign: 'left', mb: 2.5 }}>
                <Typography 
                    variant="h5" 
                    component="h2" 
                    sx={{ 
                        fontWeight: 800, 
                        color: '#0F172A',
                        letterSpacing: '-0.5px'
                    }}
                >
                    Connected Market Places
                </Typography>
            </Box>
            
            {/* Premium Container Wrapping Layer for DataGrid */}
            <Box 
                className="integrated--stores--list" 
                sx={{ 
                    width: '100%', 
                    flexGrow: 1,
                    backgroundColor: '#FFFFFF',
                    border: '1px solid #E2E8F0',
                    borderRadius: '16px',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02)',
                    overflow: 'hidden'
                }}
            >
                <DataGrid
                    getRowId={(row) => row.store_id}
                    rows={integrate && integrate.data}
                    columns={columns}
                    autoHeight={true}
                    disableRowSelectionOnClick
                    disableColumnFilter={true}
                    disableColumnMenu={true}
                    hideFooter={true}
                    slots={{
                        loadingOverlay: LinearProgress,
                    }}
                    loading={(integrate && integrate.loading)}
                    sx={{
                        border: 'none',
                        backgroundColor: '#FFFFFF',
                        
                        // Prevents header double border alignment bugs
                        '& .MuiDataGrid-topContainer': {
                            backgroundColor: '#F8FAFC',
                            '&::after': { display: 'none' }
                        },
                        
                        // Customizing Enterprise Header Styling
                        '& .MuiDataGrid-columnHeaders': {
                            backgroundColor: '#F8FAFC',
                            borderBottom: '1px solid #E2E8F0',
                            minHeight: '52px !important',
                            maxHeight: '52px !important'
                        },
                        '& .MuiDataGrid-columnHeader': {
                            color: '#475569',
                            fontWeight: 700,
                            fontSize: '13px',
                            textTransform: 'none',
                            letterSpacing: '0.1px',
                            '&:focus, &:focus-within': {
                                outline: 'none'
                            }
                        },
                        
                        // Customizing Rows and Cells Layout Bounds
                        '& .MuiDataGrid-row': {
                            transition: 'background-color 0.15s ease-in-out',
                            borderBottom: '1px solid #F1F5F9',
                            alignItems: 'center',
                            '&:hover': {
                                backgroundColor: '#F8FAFC'
                            }
                        },
                        '& .MuiDataGrid-cell': {
                            fontSize: '13.5px',
                            color: '#334155',
                            borderBottom: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            '&:focus, &:focus-within': {
                                outline: 'none'
                            }
                        },

                        // Custom Linear Progress bar tracking layout styling overrides
                        '& .MuiLinearProgress-root': {
                            height: '3px',
                            backgroundColor: '#E2E8F0',
                            '& .MuiLinearProgress-bar': {
                                backgroundColor: '#1976d2'
                            }
                        }
                    }}
                />
            </Box>
            
            <PlatformDrawer
                visible={orderDrawerVisible}
                onClose={orderOnClose}
                platform={platformName}
                storeName={storeName}
                storeId={storeId}
            />
        </>
    )
}

export default IntegratedPage;